import { EDocMetaDatum } from 'ap-openapi';

export type ScanDecisionType = 'ok' | 'warning' | 'error' | undefined;

export const useGetScanDecision = (
  eDocMetaDatum: EDocMetaDatum | undefined,
  alertType: 'warning' | 'error' | undefined,
  isEDocApReceiptTypeEnabled = true
): ScanDecisionType => {
  if (!isEDocApReceiptTypeEnabled && alertType) {
    return undefined;
  }

  if (!eDocMetaDatum) {
    return undefined;
  }

  const isDepthRequirementsMet = eDocMetaDatum.is_satisfy_depth_requirements;
  const isResolutionRequirementMet =
    eDocMetaDatum.is_satisfy_resolution_requirement;

  return isDepthRequirementsMet && isResolutionRequirementMet
    ? 'ok'
    : alertType;
};
